
<template>
  <div>
    <!-- <v-form ref="companyForm" class="px-3"> -->
      <div class="black--text">
        {{ $t('companies.main_data_form_label') }}
      </div>

      <v-row align='center' class="mt-3">
        <v-col class="pa-1" cols="12" sm="12" md="5">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$t('companies.full_name_form_label')"
            v-model="one_company.name"
            :rules="required"
          ></v-text-field>
        </v-col>
        <v-col class="pa-1" cols="12" sm="4" md="3">
          <v-radio-group v-model="one_company.document_kind" row dense mandatory class="mt-n2">
            <v-radio :label="$t('companies.cpf_form_label')" value="cpf"></v-radio>
            <v-radio :label="$t('companies.cnpj_form_label')" value="cnpj"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="pa-1" v-if="one_company.document_kind == 'cpf'" cols="12" sm="8" md="4">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$t('companies.cpf_form_label')"
            v-model="one_company.document"
            :rules="cpf"
            v-mask='"###.###.###-##"'
          ></v-text-field>
        </v-col>
        <v-col class="pa-1" v-if="one_company.document_kind == 'cnpj'" cols="12" sm="8" md="4">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$t('companies.cnpj_form_label')"
            v-model="one_company.document"
            :rules="cnpj"
            v-mask='"##.###.###/####-##"'
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row align='center' class="mt-3">
        <v-col class="pa-1" cols="12" sm="6" md="4" v-if="one_company.document_kind == 'cpf'">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$t('companies.rg_form_label')"
            v-model="one_company.rg"
            :rules="required"
          ></v-text-field>
        </v-col>
        <v-col class="pa-1" cols="12" sm="6" md="4">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$t('companies.phone_form_label')"
            v-model="one_company.phone"
            :rules="required"
            v-mask='((one_company.phone && one_company.phone.length) < 15) ? "(##) ####-####" : "(##) # ####-####"'
          ></v-text-field>
        </v-col>
        <v-col class="pa-1" cols="12" sm="6" md="4">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$t('companies.email_form_label')"
            v-model="one_company.email"
            :rules="emailRules"
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="black--text my-3">
        {{ $t('companies.address_form_label') }}
      </div>

      <address-form ref="address_form" :validate_form="true" :address="one_company.address"></address-form>

      <div class="black--text my-3">
        {{ $t('companies.subscription_form_label') }}
      </div>

      <v-row>
        <v-col class="pa-1" cols="12" sm="6" md="3">
          <vc-date-picker v-model="one_company.subscription_date">
            <template v-slot="{ inputValue, togglePopover }">
              <v-text-field rounded outlined dense class="rounder" 
                :label="$tc('companies.subscription_date_form_label')"
                :value="$dayjs(one_company.subscription_date).format('DD/MM/YYYY')"
                :rules="required"
                @focus="togglePopover()"
                readonly
              ></v-text-field>
            </template>
          </vc-date-picker>
        </v-col>
        <v-col class="pa-1" cols="12" sm="6" md="3">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$t('companies.plan_form_label')"
            v-model="one_company.plan"
            :rules="required"
          ></v-text-field>
        </v-col>
        <v-col class="pa-1" cols="12" sm="6" md="3">
          <v-select rounded outlined dense class="rounder" 
            :items="renewal_kind_options"
            v-model="one_company.renewal_kind"
            :rules="required"
            :label="$t('companies.renewal_kind_form_label')"
          ></v-select>
        </v-col>
        <v-col class="pa-1" cols="12" sm="6" md="3">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$t('companies.renewal_date_form_label')"
            v-model="one_company.renewal_date"
            :rules="required"
          ></v-text-field>
        </v-col>

        <v-col class="pa-1" cols="12" sm="6" md="4">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$tc('companies.payment_option_form_label', 1)"
            v-model="one_company.payment_option"
            :rules="required"
          ></v-text-field>
        </v-col>
        <v-col class="pa-1" cols="12" sm="6" md="4">
          <v-select rounded outlined dense class="rounder" 
            :items="pay_status_options"
            v-model="one_company.pay_status"
            :rules="required"
            :label="$tc('companies.pay_status_form_label', 1)"
          ></v-select>
        </v-col>
        <v-col class="pa-1" cols="12" sm="6" md="4">
          <v-select rounded outlined dense class="rounder" 
            :items="status_options"
            v-model="one_company.status"
            :rules="required"
            :label="$t('status')"
          ></v-select>
        </v-col>

      </v-row>


    <!-- </v-form> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import AddressForm from '../../../shared/forms/AddressForm.vue'
import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'CompanyForm',
  mixins: [ validations ],
  components: {
    AddressForm
    //ComponentName: () => import(''),
  },
  props: {
    one_company: {
      type: Object,
    },
  },
  data() {
    return {
      pay_status_options: [
        {text: this.$t('companies.pay_statuses.all_payed'), value: 'all_payed'},
        {text: this.$t('companies.pay_statuses.pending_payment'), value: 'pending_payment'},
      ],

      status_options: [
        {text: this.$tc('active', 1), value: 'active'},
        {text: this.$tc('inactive', 1), value: 'inactive'},
      ],

      renewal_kind_options: [
        {text: this.$t('companies.renewal_kinds.monthly'), value: 'monthly'},
        {text: this.$t('companies.renewal_kinds.yearly'), value: 'yearly'},
        {text: this.$t('companies.renewal_kinds.other'), value: 'other'},
      ],
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>